"use client";

import React from "react";
import Button from "@/components/atoms/Button";
import { scrollBehaviorTo } from "@/utils";

type PricingBlockCtaProps = {
  label: string;
};

const PricingBlockCta: React.FC<PricingBlockCtaProps> = ({ label }) => (
  <Button
    primary
    label={label}
    onClick={() => scrollBehaviorTo(0)}
    dataQa="pricing-block-cta"
  />
);

export default PricingBlockCta;
